import { Phone } from "lucide-react";
import { Reveal, MaskedLines } from "./Motion";
import { GoldButton, GhostButton } from "./Buttons";
import { PHONE_TEL, WHATSAPP_URL, IMAGES } from "../../lib/site";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { ZodiacWheel } from "./ZodiacWheel";

export const CTASection = () => (
  <section data-testid="cta-section" className="relative overflow-hidden px-5 py-24 sm:px-8 sm:py-32 lg:px-12">
    <div className="relative mx-auto max-w-[1400px] overflow-hidden border border-[#D4AF37]/25 bg-[#0B1120]">
      <img src={IMAGES.cosmic} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#07040D] via-[#0E081D]/90 to-[#2a1050]/60" />
      <ZodiacWheel className="pointer-events-none absolute -right-32 top-1/2 w-[520px] -translate-y-1/2 opacity-40 sm:-right-20 lg:w-[620px] lg:opacity-60" />
      <div className="relative px-6 py-16 sm:px-14 sm:py-24">
        <p className="font-cinzel text-xs tracking-[0.3em] text-[#D4AF37]">YOUR NEXT CHAPTER</p>
        <h2 className="font-display mt-5 max-w-3xl text-4xl leading-[1] text-white sm:text-6xl lg:text-7xl">
          <MaskedLines inView lines={[{ text: "The stars don't decide." }, { text: "They illuminate.", className: "italic gold-text" }]} />
        </h2>
        <Reveal delay={0.2}>
          <p className="mt-7 max-w-xl text-base leading-relaxed text-slate-300">
            Book a private consultation in Calgary or speak with us by phone or WhatsApp. Every session is confidential and unhurried.
          </p>
          <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
            <GoldButton to="/book" testId="cta-book-button">Book an Appointment</GoldButton>
            <GhostButton href={PHONE_TEL} testId="cta-call-button" icon={Phone}>Call Now</GhostButton>
            <GhostButton href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" testId="cta-whatsapp-button" icon={WhatsAppIcon}>WhatsApp</GhostButton>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
